<template>
  <div class="suggestions">
    <!-- <div class="bg"></div> -->
    <div class="special-reminder">
      <div class="title1">投诉建议</div>
      <div class="title2">特别提醒：</div>
      <div class="text">
        {{ base_setting.special_reminder }}
      </div>
      <div class="remind-online" @click="goRemind">
        在线提醒
        <i class="el-icon-arrow-right"></i>
        <div class="remind-online-dynamic"></div>
      </div>
    </div>
    <div class="sug-item">
      <div class="content">
        <div class="tab">
          <div class="tab-title">
            <div :class="['tab1', tabBtn && 'choose1']" @click="changeTab(1)">
              交易投诉
            </div>
            <div :class="['tab2', !tabBtn && 'choose2']" @click="changeTab(2)">
              售后投诉
            </div>
          </div>
          <div class="main">
            <div class="sug-img">
              <div class="img-item" v-for="(v, k) in list" :key="k">
                <img :src="v.wechat_qr" @click="copyWechat(v)" />
                <div class="number" v-if="v.wechat_type == 2">
                  微信号：{{ v.wechat
                  }}<img
                    class="copy"
                    :src="require('@/assets/image/tool/copy.png')"
                  />复制
                </div>
                <div class="number-bottom">
                  <img
                    class="copy"
                    :src="require('@/assets/image/tool/sm.png')"
                  />微信扫码
                </div>
                <div class="wx-name">{{ v.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <div class="top">
            <div class="left">
              <div class="left-title">投诉电话：</div>
              <div class="tel-1">
                {{ complaint_phone[0] }}
              </div>
              <div class="tel-2">
                {{ complaint_phone[1] }}
              </div>
            </div>
            <div class="right">
              <span>({{ base_setting.complaint_phone_time }})</span>
            </div>
          </div>
          <div class="bottom">
            <div class="left-title">投诉邮箱：</div>
            <div class="tel-1">
              {{ base_setting.complaint_email }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <input type="text" id="input" />
  </div>
</template>

<script>
import { getComplainsetting } from "@/request/API";

export default {
  name: "suggestions",
  data() {
    return {
      tabBtn: false,
      list: [],
      base_setting: {},
    };
  },
  created() {
    this.changeTab(1);
  },
  computed:{
			complaint_phone: function(){
				if(this.base_setting.complaint_phone){
					let phone1 = this.base_setting.aftersales_complaint_phone
					let phone2 = this.base_setting.complaint_phone
					return (!this.tabBtn?phone1:phone2).split(',')
				} else {
          return ''
        }
			}
		},
  methods: {
    goRemind() {
      if (!this.$store.state.loginStatus) {
        this.$router.push({
          path: "/login",
        })
        return
      }
      this.$openIM({
        gameAlias: this.base_setting.details_chat?.group_code
      })
    },
    goToCus(url) {
      window.open(url);
    },

    copyWechat(v) {
      if(v.wechat_type==1){
        return
      }
      var input = document.getElementById("input");
      input.value = v.wechat; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: "复制成功",
      });
    },
    changeTab(type) {
      this.tabBtn = type ==1?true:false
      getComplainsetting().then((res) => {
        this.base_setting = res.data
        delete this.base_setting.base_setting
        this.list = [];
        if (res.data) {
          for (let k of res.data.customer_setting) {
            if (k.customer_type == type) {
              this.list.push(k);
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@keyframes dynamic {
  100% {
    left:180px;
  }
}
.suggestions {
  position: relative;
  padding: 32px 40px 72px;
  font-family: PingFang SC-Bold, PingFang SC;
  color: var(--text-secondary, #5A5F6B);

  .bg {
    background: linear-gradient(180deg, #e9ebfb, #ffffff 100%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200px;
  }
  .sug-item {
    position: relative;
    z-index: 1;
    .content {
      display: flex;
      align-items: flex-start;
      position: relative;
      gap: 24px;
      .tab {
        width: 62%;
        .tab-title {
          padding: 6px;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          background: var(--bg-section, #F7F5F2);
          font-weight: 600;
          cursor: pointer;
          height: 54px;
          display: flex;
          text-align: center;
          user-select: none;
          box-sizing: border-box;

          .tab1,
          .tab2 {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--text-secondary, #5A5F6B);
            background: transparent;
            font-size: 16px;
            flex: 1;
            border-radius: 4px;
            transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
          }

          .tab1:hover,
          .tab2:hover {
            color: var(--text-main, #1A1D24);
            background: var(--bg-tag, #F0EDE8);
          }
          .choose1,
          .choose2 {
            background: var(--primary, #FF5A1F);
            color: #FFFFFF;
            box-shadow: none;
          }
          .choose1:hover,
          .choose2:hover {
            color: #FFFFFF;
            background: var(--primary, #FF5A1F);
          }
        }
        .main {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .sug-img {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;
            .img-item {
              width: calc((100% - 16px) / 2);
              box-sizing: border-box;
              background: var(--bg-card, #FFFFFF);
              border: 1px solid var(--border-soft, #E8E4DE);
              box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);
              border-radius: 4px;
              text-align: center;
              padding: 20px 0;
              margin-top: 20px;
              transition: box-shadow 0.2s ease, border-color 0.2s ease;

              &:first-child {
                margin-right: 16px;
              }
              &:hover {
                border-color: rgba(26, 29, 36, 0.24);
                box-shadow: 0 12px 26px rgba(26, 29, 36, 0.1);
              }
              .wx-name {
                padding: 0 10px;
                display: inline-block;
                height: 32px;
                line-height: 32px;
                margin: 0 auto 20px;
                text-align: center;
                border-radius: 4px;
                font-size: 16px;
                margin-top: 20px;
                color: var(--text-main, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
              }
              img {
                width: 137px;
                border-radius: 4px;
              }
              .name {
                margin: 0 4px;
              }

              .copy {
                width: 11px;
                height: 11px;
                margin: 0 4px;
              }

              .gr {
                width: 10px;
                height: 12px;
              }

              .jt {
                width: 3px;
                height: 5px;
              }

              .number {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 16px;
                color: var(--text-secondary, #5A5F6B);
              }

              .number-bottom {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: var(--success, #22C55E);
                margin: 14px 0 0;
              }
            }
          }
          .sug-tel {
            flex: 1;
            margin-left: 38px;
            .tel-img {
              text-align: center;
              img {
                width: 250px;
                height: 166px;
              }
            }
            .tel-box {
              .sug-img-bottom {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 42px 0 38px;
                border-radius: 4px;
                margin-top: 15px;
                background: rgb(249, 249, 249);
                width: 397px;
                height: 112px;
                box-sizing: border-box;
                .phone-box {
                  display: flex;
                  align-items: center;
                  .email-img {
                    // width: 30px;
                    height: 27px;
                  }
                  .img-h {
                    height: 20px;
                  }
                  .phone-name {
                    font-size: 16px;
                    font-weight: 600;
                    color: #2f2f2f;
                  }

                  .phone-time {
                    color: #a4a4a4;
                    font-size: 12px;
                  }
                }
                .phone-val {
                  font-size: 14px;
                  color: #000000;
                  text-align: right;
                }
                img {
                  width: 27px;
                  height: 27px;
                  margin-right: 16px;
                }

                .email-img {
                  width: 28px;
                  height: 20px;
                }
                > div {
                }
              }
            }
          }
          .sug-top-17 {
            padding-top: 17px;
          }
        }
      }
      .contact {
        width: 38%;
        display: flex;
        flex-direction: column;
        margin-top: 74px;
        .top {
          padding: 22px 24px;
          width: 100%;
          min-height: 118px;
          display: flex;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          background: var(--bg-card, #FFFFFF);
          box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);
          box-sizing: border-box;
          .left {
            flex: 2;
            position: relative;
            .left-title {
              color: var(--text-main, #111827);
              font-size: 17px;
              font-weight: 600;
              padding-left: 20px;
            }
            &::before {
              content: "";
              position: absolute;
              top: 8px;
              left: 0;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: var(--primary, #FF5A1F);
            }
            .tel-1 {
              margin-top: 15px;
              color: var(--text-secondary, #5A5F6B);
              font-size: 15px;
            }
            .tel-2 {
              margin-top: 10px;
              color: var(--text-secondary, #5A5F6B);
              font-size: 15px;
            }
          }
          .right {
            flex: 1;
            display: flex;
            justify-content: center;
            color: var(--text-muted, #9AA0AC);
            font-size: 13px;
            line-height: 20px;
          }
        }
        .bottom {
          padding: 22px 24px;
          width: 100%;
          min-height: 112px;
          display: flex;
          margin-top: 20px;
          flex-direction: column;
          position: relative;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          background: var(--bg-card, #FFFFFF);
          box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);
          box-sizing: border-box;
          .left-title {
            color: var(--text-main, #111827);
            font-size: 17px;
            font-weight: 600;
            padding-left: 20px;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              top: 8px;
              left: 0;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: var(--primary, #FF5A1F);
            }
          }
          .tel-1 {
            margin-top: 15px;
            color: var(--text-secondary, #5A5F6B);
            font-size: 15px;
          }
        }
      }
    }
    .title {
      font-size: 24px;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #1A1D24;
      position: relative;
      text-indent: 20px;
      &::before {
        content: "";
        position: absolute;
        top: 6px;
        left: 0;
        width: 8px;
        height: 19px;
        background: #1A1D24;
      }
      span {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #5A5F6B;
        margin-left: 13px;
      }
    }
  }
  .special-reminder {
    padding: 26px 32px;
    min-height: 188px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 28px;
    position: relative;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: linear-gradient(93deg, var(--brand-blue-light, #F0EDE8) 0%, rgba(255, 255, 255, 0) 100%);
    box-sizing: border-box;

    .remind-online {
      cursor: pointer;
      width: 148px;
      height: 42px;
      position: absolute;
      right: 32px;
      top: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      background: var(--primary, #FF5A1F);
      box-shadow: none;
      color: #FFFFFF;
      font-size: 15px;
      font-weight: 600;
      overflow: hidden;
      transition: background .2s ease;

      i {
        margin-left: 6px;
        font-size: 13px;
      }

      &-dynamic {
        width: 24px;
        height: 80px;
        background: rgba(255, 255, 255, .22);
        position: absolute;
        top: -10px;
        left: -70px;
        transform: rotateZ(30deg);
        animation-name: dynamic;
        animation-timing-function: ease-in-out;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
      }
      &:hover {
        background: var(--primary-hover, #E84A12);
      }
    }
    .title1 {
      font-size: 28px;
      font-family: PingFang SC-Heavy, PingFang SC;
      font-weight: 800;
      color: var(--text-main, #111827);
      letter-spacing: 0;
      margin-bottom: 20px;
    }
    .title2 {
      font-size: 18px;
      font-family: PingFang SC-Heavy, PingFang SC;
      font-weight: 800;
      color: var(--primary, #FF7A1A);
      letter-spacing: 0;
    }
    .text {
      margin-top: 10px;
      max-width: 620px;
      color: var(--text-secondary, #5A5F6B);
      font-size: 15px;
      font-family: PingFang SC-Heavy, PingFang SC;
      line-height: 26px;
      letter-spacing: 0;
    }
  }

  #input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -10;
  }
}
</style>
